import styled, { css } from 'styled-components'
import { styleReset } from 'styles/misc'
import { mq } from 'styles/mq'
import { theme } from 'styles/theme'

export const ShareContainer = styled.div<{ isOpen: boolean }>`
  position: relative;

  ${(props) =>
    props.isOpen
      ? css`
          ${ShareMenu} {
            transform: translate3d(0, 0, 0);
            transition-timing-function: ${theme.ease.out};
            transition-delay: 0.2s;
          }

          ${ShareButton} {
            opacity: 0;
            transition-delay: 0s;
          }
        `
      : css``}
`

export const ShareButton = styled.button`
  ${styleReset}
  cursor: pointer;
  display: block;
  padding: 0 0 0 3rem;
  font: inherit;
  text-transform: uppercase;
  transition: 0.3s opacity 0.55s;

  ${mq.smallOnly} {
    font-size: 2.4rem;
    padding-left: 1rem;
  }

  svg {
    display: block;
  }

  &:hover,
  &:focus {
    text-decoration: underline;
    color: var(--color-primary);
  }
`

export const ShareMenuWrapper = styled.div`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  overflow: hidden;
  pointer-events: none;
`

export const ShareMenu = styled.ul`
  transform: translate(100%, -50%);
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
  transition: all 0.6s ${theme.ease.in};
  list-style: none;
  transform: translateX(100%);
  white-space: nowrap;
  pointer-events: auto;

  li {
    margin: 0 0.4rem;
  }

  a {
    font-size: 3rem;
    display: block;
    width: 1em;
    border-radius: 50%;
    color: var(--background);
    transition: all 0.3s;
    background-color: var(--color);

    svg {
      display: block;
    }

    &:hover,
    &:focus {
      background-color: var(--color-primary);
    }
  }

  ${mq.smallOnly} {
    padding: 0.8rem 0 0.8rem 1rem;
    background-color: var(--background);

    li {
      margin: 0 0.3rem;
    }
  }
`

export const CloseButton = styled.li`
  margin-top: -0.1em;
  padding: 0.8rem;

  button {
    ${styleReset}
    display: block;
    position: relative;
    cursor: pointer;
    width: 1.6rem;
    height: 1.6rem;

    &::before,
    &::after {
      content: '';
      display: block;
      position: absolute;
      top: 50%;
      left: 0;
      width: 100%;
      border-top: 2px solid var(--color);
      transform: rotateZ(45deg);
    }

    &::after {
      transform: rotateZ(-45deg);
    }
  }
`
